export default "__VITE_ASSET__gbpz_k7E__"